import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Header.css";
import { FaHome, FaInfoCircle, FaCommentDots, FaListAlt, FaShoppingCart } from "react-icons/fa";
import logo from "../assets/koranav.svg"; 



const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prevState) => !prevState);
  };

  // Close menu if window is resized to desktop
  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <nav className="navbar">
        <div className="container">
          <div className="logo">
            <img 
              src={logo} 
              alt="Kora Insurance Logo" 
            />
            {/*This is sample text that mkaes the logo visible and grows it.*/}
          </div>
          {/* Hamburger button (visible only on mobile) */}
          <button
            className="hamburger"
            aria-label="Toggle Menu"
            aria-expanded={isMobileMenuOpen}
            onClick={toggleMobileMenu}
          >
            <span className="sr-only">Toggle Menu</span>
            <span className="hamburger-line" />
            <span className="hamburger-line" />
            <span className="hamburger-line" />
          </button>
          {/* Navigation container (shared by both mobile and desktop) */}
          <div
            className={`nav-menu ${isMobileMenuOpen ? "open" : ""}`}
            aria-hidden={!isMobileMenuOpen}
          >
            <div className="nav-left">
            <div className="icon-container" data-tooltip="Home">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? "cta-button secondary active" : "cta-button secondary"
                }
                onClick={() => setIsMobileMenuOpen(false)}
              >
      
                  <FaHome className="nav-icon" />
                 <span>Home</span>
              </NavLink>
              </div>
              <div className="icon-container" data-tooltip="About">
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  isActive ? "cta-button secondary active" : "cta-button secondary"
                }
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <FaInfoCircle className="nav-icon" />
                <span>About Us</span>
              </NavLink>
              </div>
              <div className="icon-container" data-tooltip="Testimonials">
              <NavLink
                to="/testimonials"
                className={({ isActive }) =>
                  isActive ? "cta-button secondary active" : "cta-button secondary"
                }
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <FaCommentDots className="nav-icon" />
                <span>Testimonials</span>
              </NavLink>
              </div>
            </div>
            <div className="nav-right">
            <div className="icon-container" data-tooltip="Policy Options">
              <NavLink
                to="/pricing"
                className={({ isActive }) =>
                  isActive ? "cta-button secondary active" : "cta-button secondary"
                }
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <FaListAlt className="nav-icon" />
                <span>Policy Options</span>
              </NavLink>
              </div>
              <div className="icon-container" data-tooltip="Buy Insurance">
              <NavLink
                to="/purchase"
                className={({ isActive }) =>
                  isActive ? "cta-button active" : "cta-button"
                }
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <FaShoppingCart className="nav-icon" />
                <span>Purchase an Insurance Plan</span>
      
              </NavLink>
              </div>
            </div>
          </div>
        </div>
      </nav>
      
      {isMobileMenuOpen && (
        <div className="menu-overlay open"  onClick={toggleMobileMenu}></div>
      )}
    </>
  );
};

export default Header;
